<template>
  <div class="classroom-choose">
    <router-link :to="{path: '/Classroom/ClassList'}" class="classroom-review classroom-item">
      <div class="icon"></div>
      <span>{{$t('blendType.review')}}</span>
    </router-link>
    <div class="classroom-book classroom-item" @click="showTips">
      <div class="icon"></div>
      <span>{{ $t('blendType.book') }}</span>
    </div>

    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import PopTips from "@/components/popTips";
export default {
  name: "classroom-home",
  data() {
    return {
      dialogVisable: false,
      popTipsCont: {
        title: this.$t('Common.tips'),
        context: this.$t('blendType.forword'),
        btns: [
          {
            text: this.$t('Common.confirm'),
            event: "handConfirm"
          }
        ]
      }
    };
  },
  components: { PopTips },
  created() {
    this.$emit("setReviewTitle", "KC CLUB");
    this.$store.dispatch("setLoadingStatus", false);
    this.student_id = this.$store.state.currentChild.student_id;
  },
  methods: {
    showTips() {
      this.dialogVisable = true;
    },
    handConfirm() {
      this.dialogVisable = false;
    },
    handleCloseTip() {
      this.dialogVisable = false;
    }
  }
};
</script>
<style lang="less" scoped>
.classroom-choose {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .classroom-item {
    width: 305px;
    height: 221px;
    padding: 52px 11px 39px;
    margin: 0 70px 50px 0;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
    border-radius: 17px;
    cursor: pointer;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
    .icon {
      width: 282px;
      height: 130px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    span {
      bottom: -40px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
    }
    &.classroom-review {
      .icon {
        background-image: url(../../../../assets/images/studyCenter/classroom/icon-review.png);
      }
    }
    &.classroom-book {
      .icon {
        background-image: url(../../../../assets/images/studyCenter/classroom/icon-book.png);
      }
    }
  }
}
</style>